import Component from '../Component';
import loaderSvgDefinition from '../svg-definitions/popup-loader-svg-definition.html';
import * as uiStrings from '../../uiStrings';

class Loader extends Component {
	constructor(props) {
		super(props);

		this.key = 'map-loader';

		this.messages = {
			'downloading': uiStrings.DOWNLOADING_DATA_MSG,
			'downloading-rastr': 'Stahuji data reliéfu...',
			'parsing-rastr': 'Načítám data reliéfu...',
		};
	}

	updateMessage(message) {
		this.refs['message'].textContent = this.messages[message];
	}

	render() {
		return `
            ${loaderSvgDefinition}
            <div ref="component-${this.key}" class="loader">
                <div class="loader__spinner">
                    <svg>
                        <use href="#icon-compass2"></use>
                    </svg>
                </div>
                <div class="loader__message">
                    <span ref="message" class="loader__text">${this.messages[this.props.message]}</span>
                </div>
            </div>
`;
	}
}

export default Loader;
